import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { PageSizeOption } from "@/hooks/dashboard/usePageSize";
import { useTranslation } from "react-i18next";

interface PageSizeSelectorProps {
  pageSize: PageSizeOption;
  onPageSizeChange: (size: PageSizeOption) => void;
}

export function PageSizeSelector({ pageSize, onPageSizeChange }: PageSizeSelectorProps) {
  const { t } = useTranslation();
  const pageSizeOptions: PageSizeOption[] = [10, 50, 100];

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-500">{t("sessions.show")}</span>
      <Select
        value={pageSize.toString()}
        onValueChange={(value) => onPageSizeChange(Number(value) as PageSizeOption)}
      >
        <SelectTrigger className="w-[80px]">
          <SelectValue placeholder="10" />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {pageSizeOptions.map((size) => (
              <SelectItem key={size} value={size.toString()}>
                {size}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
}